<div class="modal-header">
  <h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Board Column': 'New Board Column' }} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" novalidate>
    <div class="form-group">
      <label class="rbv-label">Name</label>
      <input type="text" maxlength="60" name="NAME" [(ngModel)]="boardColumn.NAME" #NAME="ngModel"
        class="rbv-field form-control rounded-0" [ngClass]="{ 'is-invalid': f.submitted && NAME.invalid }"
        required specialIsAlphaNumeric>
      <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
        <div *ngIf="NAME.errors.required">Name is required</div>
      </div>
    </div>
  </form>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button [disabled]="!f.form.valid" type="button" class="btn btn-rbv"
          (click)="onSubmit()">{{ isEdit ? 'Save': 'Create' }} </button>
</div>
